export default "__VITE_ASSET__ESd5qYKZ__"